import PropTypes from 'prop-types';

const AssigneeType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  kind: PropTypes.string.isRequired,
});

export default AssigneeType;



// WEBPACK FOOTER //
// ./client/app/shared/types/assignee.js